import { BlurChangeTextarea } from '../../common/components/blur-change-textarea'
import { usePageEditorContext } from '../contexts/page-editor.context'

export const BlockFieldEdit = function ({ block, field, label, rows = 4 }) {
  const pageEditorContext = usePageEditorContext() || {}

  function updateBlock (block) {
    pageEditorContext.registerUnsavedChanges()
    pageEditorContext.updateCurrentEdit({ block: { ...block } })
  }

  function getValue () {
    return block[field] || ''
  }

  function setValue (value) {
    block[field] = value
  }

  function handleChange (event) {
    const value = (event.target.value.length > 0) ? event.target.value : undefined
    setValue(value)
    updateBlock(block)
  }

  return (
    <BlurChangeTextarea
      label={label}
      size="medium"
      rows={rows}
      value={getValue()}
      onChange={handleChange}
    />
  )
}
